export enum OrderFulfillmentStatus {
  Unfulfilled = 'Unfulfilled',
  Fulfilled = 'Fulfilled',
}
